import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a67ad81c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallpaper-login" }, null, -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 col-md-6 col-sm-8 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginCard = _resolveComponent("LoginCard")!
  const _component_ChangePasswordCard = _resolveComponent("ChangePasswordCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loginState === 'login')
            ? (_openBlock(), _createBlock(_component_LoginCard, {
                key: 0,
                onLoggedIn: _ctx.afterLogin
              }, null, 8, ["onLoggedIn"]))
            : (_openBlock(), _createBlock(_component_ChangePasswordCard, {
                key: 1,
                onContinue: _ctx.goToMain
              }, null, 8, ["onContinue"]))
        ])
      ])
    ])
  ]))
}